import { render, staticRenderFns } from "./modal2.vue?vue&type=template&id=18bcb388&"
import script from "./modal2.vue?vue&type=script&lang=js&"
export * from "./modal2.vue?vue&type=script&lang=js&"
import style0 from "./modal2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willin/Documents/shiwangme/shiwangme_new_cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('18bcb388', component.options)
    } else {
      api.reload('18bcb388', component.options)
    }
    module.hot.accept("./modal2.vue?vue&type=template&id=18bcb388&", function () {
      api.rerender('18bcb388', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/components/modal2.vue"
export default component.exports